import React from 'react';
import '../blocks/ModernBlocks.css';

const AwardsBlock = ({ data }) => {
  return (
    <section className="awards-section">
      <div className="awards-container">
        <div className="awards-header">
          <h2 className="awards-title">{data.title}</h2>
          <p className="awards-subtitle">{data.subtitle}</p>
        </div>
        <div className="awards-grid">
          {data.items.map((award, index) => (
            <div key={index} className="award-card">
              <div className="award-icon">{award.icon}</div>
              <h3 className="award-title">{award.title}</h3>
              <p className="award-issuer">{award.issuer}</p>
              <p className="award-description">{award.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AwardsBlock; 